import "./styles/__container.scss"
import "./gdpr.coffee"
